import React from 'react';
import { SHOW_PARAMS } from "../../../../config";
import {Button} from "react-bootstrap";

const Row = ({ affid, subid, country, blocked, updateFactor,  ...row }) => {
    const valuesTd = SHOW_PARAMS.map(param => <td key={param}>{row[param]}</td>);

    return (
        <tr>
            <td>{affid}</td>
            <td>{subid}</td>
            <td>{country}</td>
            {valuesTd}
            <td style={{ width: '1%', whiteSpace: 'nowrap' }}>
                <Button bsStyle={'primary'} onClick={() => updateFactor(affid, subid, country)}>
                    Edit Factor
                </Button>
            </td>
        </tr>
    );
};

export default Row;



// WEBPACK FOOTER //
// ./src/scenes/PayoutFactorAll/components/Table/components/Row/index.js